import { render, staticRenderFns } from "./ModalChallenge.vue?vue&type=template&id=a26a8cfc"
import script from "./ModalChallenge.vue?vue&type=script&lang=js"
export * from "./ModalChallenge.vue?vue&type=script&lang=js"
import style0 from "./ModalChallenge.vue?vue&type=style&index=0&id=a26a8cfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports